import { z } from 'zod';

const huisnummerError = 'Huisnummer is verplicht';
export const huisnummerValidation = z
  .number({ invalid_type_error: huisnummerError, required_error: huisnummerError })
  .max(99999)
  .min(0);

const huisnummertoevoegingError = 'Toevoeging is verplicht';
export const huisnummertoevoegingValidation = z
  .string({
    invalid_type_error: huisnummertoevoegingError,
    required_error: huisnummertoevoegingError,
  })
  .max(7, 'Huisnummertoevoeging mag niet meer dan 7 karakters bevatten');

export const plaatsValidation = z
  .string({ required_error: 'Plaats is verplicht' })
  .trim()
  .min(1, 'Plaats is verplicht');

export const plaatsKortValidation = z
  .string({ required_error: 'Afgekorte plaatsnaam is verplicht' })
  .trim()
  .min(1, 'Afgekorte plaatsnaam is verplicht')
  .max(25, 'Afgekorte plaatsnaam mag niet meer dan 25 karakters bevatten');

export const postcodeValidation = z
  .string({ required_error: 'Postcode is verplicht' })
  .min(7, 'Postcode is verplicht')
  .trim()
  .max(10, 'Postcode mag niet meer dan 10 karakters bevatten');

export const straatValidation = z
  .string({ required_error: 'Straat is verplicht' })
  .trim()
  .min(1, 'Straat is verplicht');

export const straatKortValidation = z
  .string({ required_error: 'Afgekorte straatnaam is verplicht' })
  .trim()
  .min(1, 'Afgekorte straatnaam is verplicht')
  .max(24, 'Afgekorte straatnaam mag niet meer dan 24 karakters bevatten');

export const validations = {
  huisnummer: huisnummerValidation,
  huisnummertoevoeging: huisnummertoevoegingValidation,
  plaats: plaatsValidation,
  plaatsKort: plaatsKortValidation,
  postcode: postcodeValidation,
  straat: straatValidation,
  straatKort: straatKortValidation,
};
